<template>
  <div class="content-calendar-new-page content-ingestion-test-page">
    <!--<h2 class="global-h2" style="margin-bottom: 8px">Bulk Image Upload</h2>
    <p class="global-p content-ingestion-test-page__subtitle">Easily upload images to get started with Atlas.</p>
    <div class="content-ingestion-test-page__divider" />-->

    <AtlasContentIngestionPanel :customerId="customerId" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import AtlasContentIngestionPanel from "@components/ContentCalendar/AtlasContentIngestionPanel.vue";
import AdminContext from "@logic/AdminContext";

defineOptions({
  name: "AtlasContentIngestionTestPage",
});

const route = useRoute();
const customerId = computed(() => (Array.isArray(route.params.customerId) ? route.params.customerId[0] : (route.params.customerId as string)));

onMounted(async () => {
  await AdminContext.setOrgInContextFromCustomerId(customerId.value);
});
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

.content-calendar-new-page {
  width: $desktop-wide-right-col-width;
  margin: 0 auto;
}

.content-ingestion-test-page__subtitle {
  margin-bottom: 14px;
}

.content-ingestion-test-page__divider {
  border-bottom: 1px solid lightgray;
  margin-bottom: 30px;
}

@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
  .content-calendar-new-page {
    width: $desktop-right-col-width;
  }
}
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
  .content-calendar-new-page {
    width: $laptop-right-col-width;
  }
}
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
  .content-calendar-new-page {
    width: $tablet-large-content-width;
  }
}
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .content-calendar-new-page {
    width: $tablet-content-width;
  }
}
@media (max-width: $mobile-max-width) {
  .content-calendar-new-page {
    width: $mobile-content-width;
  }
}
</style>
